import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { newsActions } from '../../store/newsStore';
import { layoutActions } from '../../store/layoutStore';
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';
import { userContextActions } from '../../store/userContextStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { searchType, searchActions, defaultPaging } from '../../store/searchStore';
import { hasPermission, isOnPath, apiGet, getHostApi } from '../../store/apiWrapper';
import TopPanel from './topPanel';
import MenuLogoLink from './menuLogoLink';
import UserSettings from './userSettings';
import NavbarButton from './navbarButton';
import Notifications from './notifications';
import RightPanelOpener from './rightPanelMobilOpener';
import QuickSearchResults from '../search/quickSearchResults';

import NewsIcon from '../../img/icons/Notifikace';
import UserIcon from '../../img/icons/User';
import RepiIcon from '../../img/icons/leftPanel/BBiconsRepi';
import SkyMinderIcon from '../../img/icons/leftPanel/BBiconsSkyMinder';
import SearchIcon from '../../img/icons/Search';
import MenuSearchIcon from './menuSearchIcon';
import MonitoringIcon from '../../img/icons/Monitoring';
import ExternalWebIcon from '../../img/icons/SkyMinderAirating';

import './navMenu.scss';

class NavMenu extends React.Component {
    searchInputRef = undefined;

    initialState = {
        search: "",
        query: null,
        stamp: 0,
        validLength: false,
        subjectsLoading: false,
        subjectsError: null,
        lastSearchedSubjects: [],
        qsResult: null,
        reset: false
    };

    state = { ...this.initialState };

    opKetCodes = {
        9: function () { return false; }, /*TAB*/
        13: function () { return false; },
        16: function () { return false; }, /*SHIFT*/
        17: function () { return false; }, /*CTRL*/
        18: function () { return false; }, /*ALT*/
        27: function () { return false; }, /*ESC*/
        32: function () { return false; }, /*SPACE*/
        37: function () { return false; }, /*?*/
        38: function () { return false; }, /*?*/
        39: function () { return false; }, /*?*/
        40: function () { return true; }/*?*/
    }

    render() {
        if (isRepiWeb())
            return this.renderRepi(this.props.mobilMenu === true, this.props.authentication.isAuthorized);

        if (!this.props.authentication.isAuthorized)
            return this.renderUnauthorized();

        if (this.props.mobilMenu === true)
            return this.renderAsMobilMenu();

        return (
            <nav className={classnames('navbar', { 'withShadow': this.withShadow(), 'tinted': this.props.mobileTinted })}
                role='navigation' aria-label='main navigation' style={{ flexWrap: 'wrap', flexDirection: 'column' }}>
                <div className='navbar-menu'>
                    {this.renderDesktopLeft(true)}
                    {this.renderMobileLeft(true)}
                    {this.renderDesktopRight(true)}
                    {this.renderMobileRight(true)}
                </div>
                <div className={classnames('navbar-menu navbar-search-row desktop-hidden', {
                    'navbar-search-row-hidden': !this.props.layout.topMenuExpanded,
                    'tinted': this.props.mobileTinted
                })}>
                    {this.isAllowed('QuickSearch') && <div className='navbar-input-row'>
                        <div className='icon-wrap'>
                            <SearchIcon className='icon-centered navmenu-svg' fill='#969da1' onClick={this.onSearchSubmit} />
                        </div>
                        <input
                            ref={(el) => this.searchInputRef = el} onKeyUp={this.onInputChanged} onKeyDown={this.onSearchSubmit}
                            placeholder={this.props.translate("Search.Placeholder")} type="text" value={this.state.search}
                            onChange={(e) => this.setState({ search: e.target.value })} />
                    </div>}
                    {this.props.layout.topMenuExpanded && this.props.quickSearchResults.navMenuMobile && <div
                        style={{ display: 'block', left: 0, minWidth: '100%', position: 'absolute', top: '100%' }}
                    >
                        <QuickSearchResults subId='navMenuMobile'
                            consended={true} condenseOnlyDoB={true}
                            mode={{ buttons: 'none', extraData: 'mobile', basicLink: 'none' }}
                            searchInputRef={[this.searchInputRef]}
                            sr={this.state.qsResult} ls={[]}
                            query={this.state.query} subjectsLoading={this.state.subjectsLoading}
                        />
                    </div>}
                </div>
            </nav>
        );
    }

    componentDidMount() {
        this.props.hideQuickSearchResults('navMenuMobile');
    }

    componentDidUpdate(prevProps) {
        if ((isOnPath({ regex: /\/search$/i }) && this.props.layout.topMenuExpanded) ||
            prevProps.location !== this.props.location ||
            prevProps.isSearching !== this.props.isSearching
        ) {
            this.props.hideQuickSearchResults('navMenuMobile');
            this.props.layout.topMenuExpanded && this.props.expandTopMenu();
        }
    }

    renderUnauthorized = () => {
        return (
            <nav className={classnames('navbar', { 'withShadow': this.withShadow(), 'tinted': this.props.mobileTinted })}
                role='navigation' aria-label='main navigation' style={{ flexWrap: 'wrap', flexDirection: 'column' }}>
                <div className='navbar-menu'>
                    {this.renderDesktopLeft(false)}
                    {this.renderMobileLeft(false)}
                    {this.renderDesktopRight(false)}
                    {this.renderMobileRight(false)}
                </div>
            </nav>
        );
    }

    renderMobileLeft = (authorized) => {
        return (<div className="navbar-start hide-on-desktop" style={{ flex: 1, overflow: 'hidden' }}>
            {authorized && <div className="navbar-brand" style={{ justifyContent: 'center', width: '1.25cm' }}>
                <div className='navmenu-svg-wrapper' onClick={() => this.props.toggleBurgerMobileMenu()}
                    style={{ width: '1cm', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FontAwesomeIcon icon='bars' />
                </div>
            </div>}
            {authorized && <div className="navbar-brand">
                <TopPanel isMobile={true} {...this.props.componentProps} />
            </div>}

            {!authorized && <div className="navbar-brand"><MenuLogoLink fixed={true} tinted={this.props.mobileTinted} /></div>}
        </div>);
    }

    renderMobileRight = (authorized) => {
        if (!authorized) {
            return (
                <div className='navbar-end hide-on-desktop' style={{ marginRight: '1em' }}>
                    <div className='navbar-item dont-shrink'>
                        <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                            <Link className='navbar-link is-arrowless' to='/login'>
                                <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                                <span style={{ paddingLeft: ".5em" }}><Translate id='Login.Login' /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className='navbar-end hide-on-desktop' style={{ marginRight: '1em' }}>
                {this.isAllowed('QuickSearch') && <div className='navbar-item' onClick={() => this.processIconClick()} style={{ width: '1cm', borderLeftWidth: 0 }}>
                    <div className='navmenu-svg-wrapper'>
                        <SearchIcon className='navmenu-svg svg-standard-fill' />
                    </div>
                </div>}
                <div className='navbar-item' style={{ width: '1cm', marginLeft: '.5em' }}>
                    <div className="icon-wrap">
                        <NavbarButton
                            link={<div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                <FontAwesomeIcon icon='ellipsis-v' />
                            </div>}
                            isRight={true} dropdown={<RightPanelOpener />} noArrow={true}
                            dropdownClassname='user-dropdown height-80-scroll' />
                    </div>
                </div>
            </div>
        );
    }

    renderDesktopLeft = (authorized) => {
        return (
            <div className="navbar-start hide-on-mobile" style={{ flex: 1 }}>
                {!authorized && <MenuLogoLink fixed={this.state.fixed} />}
                {this.isAllowed('QuickSearch') && <MenuSearchIcon />}
            </div>
        );
    }

    renderDesktopRight = (authorized) => {
        if (!authorized) {
            return (
                <div className='navbar-end hide-on-mobile' style={{ fontSize: '.875em', marginRight: '1em' }}>
                    <div className='navbar-item dont-shrink'>
                        <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                            <Link className='navbar-link is-arrowless' to='/login'>
                                <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                                <span style={{ paddingLeft: ".5em" }}><Translate id='Login.Login' /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        }

        const extApps = this.generateAppLinks();
        const repiApps = this.generateRepiAppLinks();
        return (
            <div className="navbar-end hide-on-mobile" style={{ fontSize: "0.875em" }}>
                {extApps.length > 0 && <div className={classnames('navbar-item navbar-group', {
                    'is-active': extApps.map(x => this.isActive(isNullOrUndefined(x.activeLink) ? x.link : x.activeLink, x.regex)).includes(true)
                })}>
                    <div className="icon-wrap">
                        <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                            { hasPermission(null, "NarniaSecrets") ?
                            <SkyMinderIcon className="icon-centered navmenu-svg svg-standard-fill" /> :
                            <ExternalWebIcon className="icon-centered navmenu-svg svg-standard-fill" />}
                        </div>
                        {extApps.map((a, i) => this.renderMenuItemPart(i, a, extApps))}
                    </div>
                    <div className="active-notifier"></div>
                </div>}
                {repiApps.length > 0 && <div className={classnames('navbar-item navbar-group', {
                    'is-active': repiApps.map(x => this.isActive(isNullOrUndefined(x.activeLink) ? x.link : x.activeLink, x.regex)).includes(true)
                })}>
                    <div className="icon-wrap">
                        <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                        <RepiIcon className="icon-centered navmenu-svg svg-standard-fill" />
                        </div>
                        {repiApps.map((a, i) => this.renderMenuItemPart(i, a, repiApps))}
                    </div>
                    <div className="active-notifier"></div>
                </div>}
                {this.isAllowed('PanelNews') && <div className={classnames('navbar-item', { 'is-active': this.isActive('/news') })}>
                    <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                        <NavbarButton
                            link={<>
                                <div className='icon-with-attention-circle'>
                                    <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                        <NewsIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                        {this.props.news.isLoadingNotif === true && <div className={classnames('attention-circle')}><FontAwesomeIcon icon='circle-notch' spin={true} size='sm' /></div>}
                                        {(this.props.news.isLoadingNotif !== true && typeof this.props.news.totalCount === 'number' && this.props.news.totalCount > 0 && this.props.news.totalCount < 99) &&
                                            <div className={classnames('attention-circle')}>{this.props.news.totalCount}</div>
                                        }
                                    </div>
                                </div>
                                <span><Translate id='NavBar.Notifications' />&nbsp;</span>
                                {this.props.news.isLoadingNotif !== true && typeof this.props.news.totalCount === 'number' && this.props.news.totalCount > 99 &&
                                    <span className='over-3-digits-attention-circle'>{this.props.news.totalCount}</span>
                                }
                            </>}
                            dropdown={<>
                                <Notifications />
                            </>}
                            toggleMobileMenu={this.props.toggleNotificationsMobileMenu}
                            minWidth={false}
                            isRightOnSmallerDesktop />
                    </div>
                    <div className="active-notifier"></div>
                </div>}
                {this.isAllowed('MainMonitoring') && <Link
                    to='/monitoring/portfolioOverview' className={classnames("navbar-item", { 'is-active': this.isActive('/monitoring') })}
                >
                    <div className="icon-wrap" style={{ paddingLeft: "0" }}>
                        <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                            <MonitoringIcon className="icon-centered navmenu-svg svg-standard-fill" />
                        </div>
                        <div className="navbar-link is-arrowless">
                            <span><Translate id='NavBar.Monitoring' /></span>
                        </div>
                    </div>
                    <div className="active-notifier"></div>
                </Link>}
                <div className={classnames('navbar-item dont-shrink', {
                    'is-active': this.isActive('/login') || this.isActive('/user') || this.isActive('/settings')
                })}>
                    <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                        <NavbarButton isRightOnSmallerDesktop
                            link={<>
                                <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                                <span style={{ paddingLeft: ".5em" }}>{this.props.authentication.profile.username}</span>
                            </>}
                            dropdown={<>
                                <UserSettings />
                            </>}
                            toggleMobileMenu={this.props.toggleAccountMobileMenu}
                            dropdownClassname='user-dropdown'
                            minWidth={true}
                        />
                    </div>
                    <div className="active-notifier"></div>
                </div>
            </div>
        );
    }

    renderMenuItemPart = (i, a, extApps) => {
        return (
            <React.Fragment key={a.key}>
                {a.newWindow === true
                    ? <span className="navbar-link is-arrowless" onClick={() => this.openInNewWindow(a.link, this.props.translate(a.translation), a.onTab)}>
                        <span style={i > 0 ? { paddingLeft: 0 } : undefined}><Translate id={a.translation} /></span>
                    </span>
                    :
                    <Link to={a.link} className={classnames("navbar-link is-arrowless", { 'is-active': this.isActive(isNullOrUndefined(a.activeLink) ? a.link : a.activeLink, a.regex) })}>
                        <span style={i > 0 ? { paddingLeft: 0 } : undefined}><Translate id={a.translation} /></span>
                    </Link>}
                {i < extApps.length - 1 ? <span className="item-separator"></span> : null}
            </React.Fragment>
        )
    }

    renderAsMobilMenu = () => {
        const extApps = this.generateAppLinks();
        const repiApps = this.generateRepiAppLinks();

        return (
            <aside className="menu">
                <ul className="menu-list">
                    {this.isAllowed('PanelNews') && <li>
                        <a className={classnames({ 'is-active': this.isActive('/news') })} onClick={() => this.props.toggleNotificationsMobileMenu()}>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <NewsIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        <Translate id='NavBar.Notifications' />
                                    </span>
                                </div>
                            </div>
                        </a>
                    </li>}
                    {this.isAllowed('MainMonitoring') && <li>
                        <Link to='/monitoring/portfolioOverview' className={classnames({ 'is-active': this.isActive('/monitoring') })}>
                            <div className='icon-holder'>
                                <div className="icon-wrap">
                                    <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                        <MonitoringIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                    </div>
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        <Translate id='NavBar.Monitoring' />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    </li>}
                </ul>
                {this.renderMobileItemSection(extApps, hasPermission(null, "NarniaSecrets") ? SkyMinderIcon : ExternalWebIcon, 'User.OtherServices' )}
                {this.renderMobileItemSection(repiApps, RepiIcon, 'NavBar.Repi' )}
                <ul className="menu-list">
                    <li>
                        <a
                            onClick={() => this.props.toggleAccountMobileMenu()}>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        {this.props.authentication.profile.username}
                                    </span>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li className='noborder'>
                        <a
                            onClick={() => { this.props.resetSubjects(); this.props.logoutNotifications(); this.props.logout() }}>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <FontAwesomeIcon icon='sign-out-alt' />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        <Translate id='DashboardLayout.SignOut' />
                                    </span>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </aside>
        );
    }

    renderMobileItemSection = (extApps, Icon, label) => {
        return(
            <>
                {extApps.length > 0 && <ul className="menu-list">
                    <div className="menu-label" style={{ paddingBottom: 0 }}>
                        <div className='icon-label'>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <Icon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        <Translate id={label} />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <li>
                        <ul style={{ marginTop: 0, borderLeftWidth: 0, paddingLeft: '4em' }}>
                            {extApps.map((a, i) => <React.Fragment key={a.key}>
                                {a.newWindow === true && <li>
                                    <a onClick={() => this.openInNewWindow(a.link, this.props.translate(a.translation), a.onTab)}>
                                        <Translate id={a.translation} />
                                    </a>
                                </li>}
                                {a.newWindow !== true && <li>
                                    <Link to={a.link} className={classnames("navbar-link is-arrowless", { 'is-active': this.isActive(a.link) })}>
                                        <Translate id={a.translation} />
                                    </Link>
                                </li>}
                            </React.Fragment>)}
                        </ul>
                    </li>
                </ul>}
            </>
        );
    }

    renderRepi = (mobile, authorized) => {
        if (mobile)
            return this.renderRepiMobile();

        // TODO: Finish mobile renders (MR-415)
        return (
            <nav className={classnames('navbar', { 'withShadow': this.withShadow(), 'tinted': this.props.mobileTinted })}
                role='navigation' aria-label='main navigation' style={{ flexWrap: 'wrap', flexDirection: 'column' }}>
                <div className='navbar-menu'>
                    {this.renderDesktopLeftRepi()}
                    {this.renderMobileLeft(authorized)}
                    {this.renderDesktopRightRepi(authorized)}
                    {this.renderMobileRight(authorized)}
                </div>
            </nav>
        );
    }

    renderDesktopLeftRepi = () => {
        return (
            <div className="navbar-start hide-on-mobile" style={{ flex: 1 }}>
                <MenuLogoLink fixed={this.state.fixed} repi={true} />
            </div>
        );
    }

    renderDesktopRightRepi = (authorized) => {
        if (!authorized) {
            return (
                <div className='navbar-end hide-on-mobile' style={{ fontSize: '.875em', marginRight: '1em' }}>
                    <div className='navbar-item dont-shrink'>
                        <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                            <Link className='navbar-link is-arrowless' to='/login'>
                                <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                                <span style={{ paddingLeft: ".5em" }}><Translate id='Login.Login' /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="navbar-end hide-on-mobile" style={{ fontSize: "0.875em" }}>
                {this.isAllowed('PanelNews') && <div className={classnames('navbar-item', { 'is-active': this.isActive('/news') })}>
                    <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                        <NavbarButton
                            link={<>
                                <div className='icon-with-attention-circle'>
                                    <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                        <NewsIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                        {this.props.news.isLoadingNotif === true && <div className={classnames('attention-circle')}>
                                            <FontAwesomeIcon icon='circle-notch' spin={true} size='sm' />
                                        </div>}
                                        {(this.props.news.isLoadingNotif !== true && typeof this.props.news.totalCount === 'number' && this.props.news.totalCount > 0
                                            && this.props.news.totalCount < 99) && <div className={classnames('attention-circle')}
                                        >
                                            {this.props.news.totalCount}
                                        </div>
                                        }
                                    </div>
                                </div>
                                <span><Translate id='NavBar.Notifications' />&nbsp;</span>
                                {this.props.news.isLoadingNotif !== true && typeof this.props.news.totalCount === 'number' && this.props.news.totalCount > 99 &&
                                    <span className='over-3-digits-attention-circle'>{this.props.news.totalCount}</span>
                                }
                            </>}
                            dropdown={<Notifications />}
                            toggleMobileMenu={this.props.toggleNotificationsMobileMenu}
                            minWidth={false}
                            isRightOnSmallerDesktop
                        />
                    </div>
                    <div className="active-notifier" />
                </div>}
                <div className={classnames('navbar-item dont-shrink', {
                    'is-active': this.isActive('/login') || this.isActive('/user') || this.isActive('/settings')
                })}>
                    <div className="icon-wrap" style={{ paddingLeft: "0", paddingRight: "0" }}>
                        <NavbarButton isRightOnSmallerDesktop
                            link={<>
                                <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })}>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                                <span style={{ paddingLeft: ".5em" }}>{this.props.authentication.profile.username}</span>
                            </>}
                            dropdown={<UserSettings />}
                            toggleMobileMenu={this.props.toggleAccountMobileMenu}
                            dropdownClassname='user-dropdown'
                            minWidth={true}
                        />
                    </div>
                    <div className="active-notifier" />
                </div>
            </div>
        );
    }

    renderRepiMobile = () => {
        const repiApps = this.generateRepiAppLinks();

        return (
            <aside className="menu">
                <ul className="menu-list">
                    {this.isAllowed('PanelNews') && <li>
                        <a className={classnames({ 'is-active': this.isActive('/news') })} onClick={() => this.props.toggleNotificationsMobileMenu()}>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <NewsIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        <Translate id='NavBar.Notifications' />
                                    </span>
                                </div>
                            </div>
                        </a>
                    </li>}
                </ul>
                {hasPermission(null, "NarniaSecrets") && this.renderMobileItemSection(repiApps, RepiIcon, 'NavBar.Repi' )}
                <ul className="menu-list">
                    <li>
                        <a
                            onClick={() => this.props.toggleAccountMobileMenu()}>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <UserIcon className="icon-centered navmenu-svg svg-standard-fill" />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        {this.props.authentication.profile.username}
                                    </span>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li className='noborder'>
                        <a
                            onClick={() => { this.props.resetSubjects(); this.props.logoutNotifications(); this.props.logout() }}>
                            <div className='icon-holder'>
                                <div className='icon-wrap'>
                                    <FontAwesomeIcon icon='sign-out-alt' />
                                </div>
                            </div>
                            <div className='text-wrapper'>
                                <div className='text'>
                                    <span className='span-wrapper'>
                                        <Translate id='DashboardLayout.SignOut' />
                                    </span>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </aside>
        );
    }

    processIconClick = () => {
        if (isOnPath({ regex: /^\/search$/i })) {
            if (this.props.topMenuExpanded) {
                this.props.expandTopMenu();
            }
            this.props.focusQuickSearch();
        } else {
            this.props.hideQuickSearchResults('navMenuMobile');
            this.props.expandTopMenu();
            this.setState({ ...this.initialState });
        }
    }

    renderMenuItem = (link, Icon, translation, requiresNarnia = true) => {
        if ((requiresNarnia && this.isAllowed('NarniaSecrets')) || (!requiresNarnia)) {
            return (
                <Link to={link} className={classnames("item", { 'is-active': this.isActive(link) })}>
                    <span className="icon-wrapper">
                        <Icon className="icon-centered" style={{ width: '2em', height: '2em' }} />
                        <span><Translate id={translation} /></span>
                    </span>
                    <span></span>
                </Link>
            )
        }

        return null;
    }

    onSearchSubmit = event => {
        if (isNullOrUndefined(event) || (event.type === 'keydown' && event.key !== 'Enter'))
            return;

        const term = this.state.search.trim();
        if (term !== null && term !== undefined && term.length > 2) {
            const dob = (term || '').replace(/\s/g, '').replace(/[/\\]/g, '');
            const isDob = moment(dob, 'DD.MM.YYYY', true).isValid() || moment(dob, 'D.M.YYYY', true).isValid();
            const isId = !isDob && dob.length >= 9 && dob.length <= 10 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length;

            if (isOnPath({ prefix: "/search/results" })) {
                this.props.topMenuExpanded && this.props.expandTopMenu();
                let params = { country: 3, actualOnly: true };
                if (isDob || isId) {
                    params.isPo = false;
                    params.dob = term;
                } else {
                    params.name = term;
                }
                //makes the query
                this.props.getSubjects(searchType.BS, params, { ...defaultPaging });
            }
            //insert into history so there is track of what has been searched
            clearTimeout(this.state.pendingReq);
            if (isDob || isId) {
                this.props.history.push(`/search/results?type=${encodeURIComponent(searchType.BS)}&isPo=false&dob=${encodeURIComponent(term)}`);
            } else {
                this.props.history.push(`/search/results?type=${encodeURIComponent(searchType.BS)}&q=${encodeURIComponent(term)}`);
            }
            this.props.hideQuickSearchResults('navMenuMobile');
            this.setState({ validLength: false, query: '', search: '' });
        }
    }

    onInputChanged = (event) => {
        if (isNullOrUndefined(event) || isNullOrUndefined(event.target) || isNullOrUndefined(event.target.value)) {
            this.props.hideQuickSearchResults('navMenuMobile');
            this.setState({ query: term });
            return;
        }

        const keyCode = event.keyCode.toString();
        if (Object.keys(this.opKetCodes).indexOf(keyCode) !== -1) {
            if (!this.opKetCodes[keyCode]())
                if (keyCode !== "32")
                    return;
                else if ((event.target || {}).selectionEnd === ((event.target || {}).value || {}).length)   //skip space only in the end
                    return;
        }

        const term = event.target.value.trim();
        if (event.target.value !== null && event.target.value !== undefined && term.length <= 2) {
            this.props.hideQuickSearchResults('navMenuMobile');
            this.setState({ qsResult: null, query: term });
        }
        else if (event.target.value !== null && event.target.value !== undefined && term.length >= 3) {
            const dob = (term || '').replace(/\s/g, '').replace(/[/\\]/g, '');
            const isDob = moment(dob, 'DD.MM.YYYY', true).isValid() || moment(dob, 'D.M.YYYY', true).isValid();
            const isId = !isDob && dob.length >= 9 && dob.length <= 10 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length;

            const newStamp = this.state.stamp + 1;
            this.props.showQuickSearchResults('navMenuMobile');
            this.setState({ validLength: true, query: term, stamp: newStamp });
            this.loadQs((isDob || isId) ? '' : term, (isDob || isId) ? dob : '', newStamp);
        } else {
            this.setState({ validLength: false, query: term });
        }
    }

    loadQs = (query, dob, stamp) => {
        this.setState({ isSearching: true });
        if (this.state.pendingReq !== undefined) {
            clearTimeout(this.state.pendingReq);
        }
        this.setState({
            pendingReq: setTimeout(function () {
                apiGet.call(this, `${getHostApi()}/api/search/quick`, { query, stamp, dob },
                    res => {
                        if (res.data.stamp === this.state.stamp) {
                            this.setState({ qsResult: res.data });
                            this.props.syncFromSearch(res.data.subjects);
                        }
                    },
                    err => { },
                    alw => this.setState({ isSearching: false }))
            }.bind(this), 125)
        });
    }

    generateAppLinks = () => {
        const apps = [
            {
                key: "skyminder", link: this.props.authentication.profile.agentLanguage === "sk-SK" ? "https://www.skyminder.sk/" : "https://www.skyminder.cz/",
                translation: "NavBar.Skyminder", permissions: ["!SkyMinderRegistered", "!SkyMinderDisabled"], newWindow: true, onTab: true
            },
            { key: "skyminderSso", link: "/skyminder/sso", translation: "NavBar.Skyminder", permissions: ["SkyMinderRegistered", "!SkyMinderDisabled"], newWindow: true },
        ];

        if (this.props.authentication.irating)
            apps.push({ key: "irating", link: "/irating", translation: "NavBar.Irating", permissions: [], newWindow: true, onTab: true });

        return apps.filter(f => f.permissions.map(p => this.checkExternalAppPermission(p)).reduce((a, b) => a && b, true));
    }

    generateRepiAppLinks = () => {
        const apps = [
            { key: "repi", link: this.getExternalRepiLink(),
                translation: "NavBar.Repi", permissions: ["!MainRepi"], newWindow: true, onTab: true },
            { key: "repi", link: "/repi/search", translation: "NavBar.Repi", permissions: ["MainRepi"],
                newWindow: false, onTab: false, activeLink: /repi\/(search|report|results)/i, regex: true },
            { key: "itrade", link: "/itrade", translation: "NavBar.Itrade", permissions: ["EmbeddedItrade"] },
            { key: "itrade", link: this.getExternalRepiLink(),
                translation: "NavBar.Itrade", permissions: ["!EmbeddedItrade"], newWindow: true, onTab: true }
        ];

        return apps.filter(f => f.permissions.map(p => this.checkExternalAppPermission(p)).reduce((a, b) => a && b, true));
    }

    getExternalRepiLink = () => {
        switch (this.props.authentication.profile.agentLanguage) {
            case "cs-CZ": return "https://www.mcribis.cz/sluzby/repi/";
            case "sk-SK": return "https://www.mcribis.sk/sluzby/repi/";
            default: return "https://www.mcribis.cz/en/services/repi/";
        }
    }

    checkExternalAppPermission = (perm) => {
        if (isNullOrUndefined(perm) || perm.length === 0)
            return true;
        return (perm[0] === "!") ? !this.isAllowed(perm.substring(1)) : this.isAllowed(perm);
    }

    openInNewWindow = (url, name, onTab, width = 1024, height = 700) => {
        if (onTab === true)
            this.openInNewTab(url, name)
        else
            window.open(url, name, `width=${width}, height=${height}, location=no, status=no, toolbar=no, menubar=no, scrollbars=yes, resizable=yes`);
    }

    openInNewTab = (url, name) => {
        window.open(url, name, `location=yes, status=yes, toolbar=yes, menubar=yes, scrollbars=yes, resizable=yes`);
    }

    withShadow() {
        if (isOnPath({ prefix: "/report" }) ||
            isOnPath({ prefix: "/relation-chart" }) ||
            isOnPath({ prefix: "/itrade" }) ||
            isOnPath({ regex: /(search\/results)/i }))
            return false;
        return this.props.layout.scrolled;
    }

    isActive = (item, regex = false) => {
        if(regex)
            return isOnPath({ regex: item });
        else
        return isOnPath({ prefix: item });
    }

    isAllowed = (permision) => {
        return hasPermission(null, permision);
    }
}

NavMenu.propTypes = {
    collapsed: PropTypes.bool.isRequired,
    navItems: PropTypes.array,
    toggle: PropTypes.func.isRequired
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.userContext, ...state.search, layout: state.layout, news: state.news }),
    dispatch => bindActionCreators(Object.assign({}, userContextActions, searchActions, lastSubjectActions, newsActions, layoutActions), dispatch)
)(NavMenu)));